const Config = {
   socketUri: process.env.REACT_APP_SOCKET_URL,
   apiUri: process.env.REACT_APP_API_URL,
};

export default Config;
